const setSimulationTimestampDataStorage = (timestamp: string) => {
  localStorage.setItem('lastSimulationTimestamp', timestamp)
}

const getSimulationTimestampDataStorage = () => {
  return localStorage.getItem('lastSimulationTimestamp')
}

const clearSimulationTimestampDataStorage = () => {
  localStorage.removeItem('lastSimulationTimestamp')
}

const clearSimulationDataStorage = () => {
  clearSimulationTimestampDataStorage()
}

export {
  setSimulationTimestampDataStorage,
  getSimulationTimestampDataStorage,
  clearSimulationTimestampDataStorage,
  clearSimulationDataStorage
}
